import { FC, ChangeEvent, FocusEvent, MouseEvent } from 'react';
import DropDown from '../../DropDown/DropDown';
import { MLPVersion } from '../../Input/Input';
import { PhoneNumberMLPProps } from '../types/propsType';
import { TooltipPreference } from '../../Tooltip/Tooltip';
import { Data } from '../../DropDown/types/propsType';
import { DropDownValidations, DropDownFilterBy } from '../../DropDown/types/enums';
import styles from '../PhoneNumber.module.scss';

/**
 *
 *  by default : disabledFilter, dropdownDisabled, inputDisabled is false;
 *  name is required prop
 */

const PhoneNumberMLP1: FC<PhoneNumberMLPProps> = ({
  name,
  dropdownLabel = '',
  dropdownValue,
  dropdownLabelInfo = '',
  dropdownLabelInfoPreference = TooltipPreference.RIGHT,
  disabledFilter = false,
  dropdownDisabled,
  configData,
  inputValue = '',
  inputDisabled = false,
  onInputChange,
  status,
  onBlur,
  phoneCountryData,
  isElementFocused,
  isHovered,
  setIsElementFocused,
  setIsHovered,
  onMouseOver,
  onMouseLeave,
  onFocus,
  applySearchFilter,
  searchFilterPlaceHolder = 'Search',
  searchFilterValue,
  setSearchFilterValue,
  ...restProps
}): JSX.Element => {
  const handleMouseOver = (e: MouseEvent<HTMLInputElement>) => {
    if (!inputDisabled) {
      setIsHovered(true);
    }
    onMouseOver && onMouseOver(e);
  };

  const handleMouseLeave = (e: MouseEvent<HTMLInputElement>) => {
    setIsHovered(false);
    onMouseLeave && onMouseLeave(e);
  };

  const handleFocus = (e: FocusEvent<HTMLInputElement>) => {
    if (!inputDisabled) {
      setIsElementFocused(true);
    }
    onFocus && onFocus(e);
  };

  const handleBlur = (e: FocusEvent<HTMLInputElement>) => {
    setIsElementFocused(false);
    onBlur && onBlur(e);
  };

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    onInputChange && onInputChange(e.target.value);
  };

  const handleSearchQueryChange = (e: ChangeEvent<HTMLInputElement>) => {
    const regex = /^[A-Za-z]+$/; //Country name filter only allow alphabets
    if (!e.target.value || regex.test(e.target.value)) {
      setSearchFilterValue && setSearchFilterValue(e.target.value);
    }
  };

  return (
    <section
      className={`${styles['phone-number-body']} ${isHovered ? styles['element-ishovered'] : ''} ${
        isElementFocused ? styles['element-isfocused'] : ''
      }`}
    >
      <span
        className={`${styles['dropdown-number']} ${
          dropdownDisabled || inputDisabled ? styles['disable-dropdown'] : ''
        } ${status ? styles[status] : ''}`}
      >
        <DropDown
          mlpVersion={MLPVersion.ONE}
          testId="number-dropDown"
          disabled={dropdownDisabled || inputDisabled}
          name={name}
          data={phoneCountryData}
          configData={configData}
          value={inputValue}
          dropdownLabel={dropdownLabel}
          isPhoneNumberMLP1
          selectedCountry={dropdownValue as Data}
          labelInfo={dropdownLabelInfo}
          labelInfoPreference={dropdownLabelInfoPreference}
          disabledFilter={disabledFilter}
          readOnly={inputDisabled}
          onMouseOver={handleMouseOver}
          onMouseLeave={handleMouseLeave}
          onFocus={handleFocus}
          onBlur={handleBlur}
          onChange={handleChange}
          status={status as DropDownValidations | undefined}
          applySearchFilter={applySearchFilter}
          searchFilterPlaceHolder={searchFilterPlaceHolder}
          searchFilterValue={searchFilterValue}
          onChangeSearchQuery={handleSearchQueryChange}
          filterBy={DropDownFilterBy.STARTS_WITH}
          {...restProps}
        />
      </span>
    </section>
  );
};

export default PhoneNumberMLP1;
